import type { AuthUser } from "$/lib/types/api/user.types";
import { restApiClient } from "../restApiClient";

export default async function getMe() {
  return restApiClient.url("/auth/me").get<AuthUser>();
}
